import React from "react";
import { Link } from "react-router-dom";

import Button from "./Button";

import styled from "styled-components/macro";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  min-height: 40px;

  h1 {
    line-height: 1;
    margin: 0;
  }
`;

const Header = ({
  title,
  action,
  label = "Acción",
  link,
  actionProps,
  children,
  ...props
}) => (
  <Container {...props}>
    <h1>{title}</h1>
    {children}
    {action && (
      <Button onClick={action} type="primary" {...actionProps}>
        {label}
      </Button>
    )}
    {link && (
      <Link to={link} {...actionProps}>
        <Button style={{ minWidth: 180 }}>{label}</Button>
      </Link>
    )}
  </Container>
);

export default Header;
